<h2 mat-dialog-title>Edit Question & Answer</h2>

<mat-dialog-content>
    <form [formGroup]="qaForm" class="qa-form">
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Question</mat-label>
            <textarea matInput formControlName="question" rows="3" placeholder="Enter your question"></textarea>
            <mat-error *ngIf="qaForm.get('question')?.hasError('required')">
                Question is required
            </mat-error>
            <mat-error *ngIf="qaForm.get('question')?.hasError('minlength')">
                Question must be at least 3 characters
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Answer</mat-label>
            <textarea matInput formControlName="answer" rows="5" placeholder="Enter the answer"></textarea>
            <mat-error *ngIf="qaForm.get('answer')?.hasError('required')">
                Answer is required
            </mat-error>
            <mat-error *ngIf="qaForm.get('answer')?.hasError('minlength')">
                Answer must be at least 3 characters
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Category (Optional)</mat-label>
            <input matInput formControlName="category" placeholder="Enter category">
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Video ID (Optional)</mat-label>
            <input matInput formControlName="videoId" placeholder="Enter video ID">
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!qaForm.valid">
        Update Q&A
    </button>
</mat-dialog-actions>